import { render } from "./AddPlant.vue?vue&type=template&id=0c68e945"
import script from "./AddPlant.vue?vue&type=script&lang=js"
export * from "./AddPlant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__